"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FORM_TYPE_INFO = exports.FORM_TYPE_EMAIL = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

var _classnames = _interopRequireDefault(require("classnames"));

var _formik = require("formik");

var _reactPhoneNumberInput = require("react-phone-number-input");

var _util = require("../contentful-views/util");

var _util2 = require("../../util");

var _reactUtils = require("../react-utils");

var _madLibFields = require("./mad-lib-fields");

var _madLibCards = _interopRequireDefault(require("./mad-lib-cards/mad-lib-cards"));

var _madLibRadioButtons = _interopRequireWildcard(require("./mad-lib-radio-buttons"));

var _contentfulViews = require("../contentful-views");

var _button = _interopRequireDefault(require("../button"));

require("./mad-lib-form.less");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FORM_TYPE_EMAIL = 'email';
exports.FORM_TYPE_EMAIL = FORM_TYPE_EMAIL;
var FORM_TYPE_INFO = 'info';
/**
 * Validates email form values
 * @param {String} args.email Email field
 * @param {String} args.name Name field
 */

exports.FORM_TYPE_INFO = FORM_TYPE_INFO;

var validateEmail = function validateEmail(_ref) {
  var email = _ref.email,
      name = _ref.name;
  var errors = {}; // validate name

  var nameValidError = (0, _util2.validateName)(name);

  if (nameValidError) {
    errors.name = nameValidError;
  } else if (!name) {
    errors.name = 'Name is required.';
  } // validate email


  if (!email) {
    errors.email = 'Email is required.';
  }

  return errors;
};
/**
 * Validates an `info` form type, which could have any of the fields in
 * `fieldSubstitutions`. For an `info` form, all inputs are considered optional,
 * but we will validate names and phone numbers if a user decides to provide
 * them. Email addresses are validated using the browser's built-in validation
 * @param {object} args
 * @param {String} args.name
 * @param {String} args.phone
 */


var validateInfo = function validateInfo(_ref2) {
  var name = _ref2.name,
      phone = _ref2.phone;
  var errors = {};
  var nameValidError = name && (0, _util2.validateName)(name);

  if (nameValidError) {
    errors.name = nameValidError;
  }

  if (phone && !(0, _reactPhoneNumberInput.isPossiblePhoneNumber)(phone)) {
    errors.phone = 'Invalid phone number';
  }

  return errors;
};
/**
 * validateForm is called by Formik to validate form values.
 * https://jaredpalmer.com/formik/docs/api/formik#validate-values-values-formikerrors-values-promise-any
 * @param {Object} Fields value object passed by Formik.
 * @returns {Object} Object of field keys with error strings, empty if no errors.
 */


var validateForm = function validateForm(formType) {
  if (formType === FORM_TYPE_EMAIL) {
    return validateEmail;
  }

  if (formType === FORM_TYPE_INFO) {
    return validateInfo;
  }

  return function () {};
};
/**
 * fieldSubstitutions returns an object mapping macros to components.
 * Passed to componentSubstitution as component argument.
 * @param {Object} placeholders Object of values to be used as placeholders for input fields.
 */


var fieldSubstitutions = {
  email: _madLibFields.emailField,
  name: _madLibFields.nameField,
  info: _madLibFields.infoField,
  phone: _madLibFields.phoneField
};
/**
 * MadLibForm renders form elements inline with text, creating an 'madlib'
 * @param {object} bannerImage Image to display behind the salutation text.
 * @param {function} cancelCTA Object of values for rendering secondary Button
 * @param {string} formType Type of form, only two options now.
 *                          Use the appropriate value for text macros provided.
 * @param {object} image Image displayed to left of fields on desktop, and above fields on mobile.
 * @param {boolean} inDialog Tell this Form that it is in a dialog and to update styles.
 * @param {function} onCancel Callback to cancel form editing.
 * @param {string} pendingText Text for the primaryCTA when submit is pending.
 * @param {object} placeholders Placeholder strings for inline fields. See fieldSubstituions.
 * @param {function} primaryCTA Object of values for rendering primary Button
 * @param {object} radioButtons If provided, renders radio buttons
 * @param {string} salutation Salutation / header value
 * @param {string} secondarySalutation Text below the primary salutation
 * @param {string} salutationColor classes for salutation to affect color. 'blue', 'red'
 * @param {string} text Mad Lib text, {{macro}}s for rendering form fields.
 *                      Accepted macros are: {{name}}, {{info}}, {{email}}, {{phone}}
 */

var MadLibForm = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(MadLibForm, _React$PureComponent);

  var _super = _createSuper(MadLibForm);

  function MadLibForm() {
    var _this;

    _classCallCheck(this, MadLibForm);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "submitForm", function (values, formikActions) {
      var onSubmit = _this.props.onSubmit;
      onSubmit(values, formikActions);
    });

    return _this;
  }

  _createClass(MadLibForm, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          bannerImage = _this$props.bannerImage,
          className = _this$props.className,
          cancelCTA = _this$props.cancelCTA,
          formType = _this$props.formType,
          image = _this$props.image,
          inDialog = _this$props.inDialog,
          onCancel = _this$props.onCancel,
          pendingText = _this$props.pendingText,
          primaryCTA = _this$props.primaryCTA,
          salutation = _this$props.salutation,
          secondarySalutation = _this$props.secondarySalutation,
          salutationColor = _this$props.salutationColor,
          text = _this$props.text,
          segmentationCards = _this$props.segmentationCards,
          radioButtons = _this$props.radioButtons;
      var initialValues = {
        email: '',
        name: '',
        phone: '',
        segment: {}
      };
      var validate = null;
      var cards;

      if (formType === 'cards') {
        cards = /*#__PURE__*/_react["default"].createElement(_madLibCards["default"], {
          segmentationCards: segmentationCards,
          inDialog: inDialog
        });
      }

      var radios;

      if (formType === 'radioButtons' && radioButtons) {
        validate = (0, _madLibRadioButtons.getRadioButtonsValidator)(radioButtons.name);
        initialValues = _objectSpread(_objectSpread({}, initialValues), (0, _madLibRadioButtons.getRadioButtonsInitialValues)(radioButtons.name));
        radios = /*#__PURE__*/_react["default"].createElement(_madLibRadioButtons["default"], {
          name: radioButtons.name,
          includeOtherOption: radioButtons.includeOtherOption,
          options: radioButtons.options
        });
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('MadLibForm', formType, className, {
          inDialog: inDialog
        })
      }, image ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "madLibSideContent"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "madLibImage"
      }, /*#__PURE__*/_react["default"].createElement(_contentfulViews.Image, {
        media: image
      }))) : null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "madLibMainContent"
      }, bannerImage ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "madLibBanner"
      }, /*#__PURE__*/_react["default"].createElement(_contentfulViews.Image, {
        media: bannerImage
      }), /*#__PURE__*/_react["default"].createElement("p", {
        className: "salutation"
      }, salutation)) : /*#__PURE__*/_react["default"].createElement("p", {
        className: (0, _classnames["default"])('salutation', salutationColor)
      }, salutation), secondarySalutation ? /*#__PURE__*/_react["default"].createElement("p", {
        className: "h3"
      }, secondarySalutation) : null, /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
        initialValues: initialValues,
        validate: validate || validateForm(formType),
        onSubmit: this.submitForm
      }, function (_ref3) {
        var isSubmitting = _ref3.isSubmitting;
        return /*#__PURE__*/_react["default"].createElement(_formik.Form, null, /*#__PURE__*/_react["default"].createElement("div", {
          className: "madLibText"
        }, (0, _util.componentSubstitution)(text, fieldSubstitutions), cards), radios, /*#__PURE__*/_react["default"].createElement("div", {
          className: "buttonGroup"
        }, (0, _reactUtils.includeWhen)(!_lodash["default"].isEmpty(primaryCTA), function () {
          return /*#__PURE__*/_react["default"].createElement(_button["default"], _extends({}, primaryCTA.props, {
            disabled: isSubmitting,
            isSubmit: true
          }), isSubmitting ? pendingText : primaryCTA.text);
        }), (0, _reactUtils.includeWhen)(!_lodash["default"].isEmpty(cancelCTA), function () {
          return /*#__PURE__*/_react["default"].createElement(_button["default"], _extends({}, cancelCTA.props, {
            onClick: onCancel,
            disabled: isSubmitting
          }), cancelCTA.text);
        })));
      })));
    }
  }]);

  return MadLibForm;
}(_react["default"].PureComponent);

MadLibForm.propTypes = {
  bannerImage: _propTypes["default"].shape({}),
  className: _propTypes["default"].string,
  formType: _propTypes["default"].oneOf(['email', 'info', 'cards', 'radioButtons']),
  image: _propTypes["default"].shape({}),
  inDialog: _propTypes["default"].bool,
  onCancel: _propTypes["default"].func,
  onSubmit: _propTypes["default"].func,
  pendingText: _propTypes["default"].string,
  primaryCTA: _propTypes["default"].shape({
    props: _propTypes["default"].shape({}),
    text: _propTypes["default"].string
  }),
  radioButtons: _propTypes["default"].shape({
    name: _propTypes["default"].string,
    includeOtherOption: _propTypes["default"].bool,
    options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      value: _propTypes["default"].string,
      label: _propTypes["default"].string
    }))
  }),
  salutation: _propTypes["default"].string,
  secondarySalutation: _propTypes["default"].string,
  salutationColor: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({})]),
  segmentationCards: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    image: _propTypes["default"].shape({}),
    // contentful media object
    title: _propTypes["default"].string
  })),
  cancelCTA: _propTypes["default"].shape({
    props: _propTypes["default"].shape({}),
    text: _propTypes["default"].string
  }),
  text: _propTypes["default"].string
};
MadLibForm.defaultProps = {
  bannerImage: null,
  className: null,
  image: null,
  formType: null,
  inDialog: false,
  onCancel: _lodash["default"].noop,
  onSubmit: _lodash["default"].noop,
  pendingText: 'Submitting',
  primaryCTA: {},
  radioButtons: null,
  salutation: null,
  secondarySalutation: null,
  salutationColor: null,
  segmentationCards: [],
  cancelCTA: {},
  text: null
};
var _default = MadLibForm;
exports["default"] = _default;